import { useRecoilState } from 'recoil';
import { CurrentBusinessAtom, syncCurrentBusinessToStorage } from './atom';

export const useCurrentBusiness = () => {
  const [currentBusinessId, setCurrentBusinessId] = useRecoilState(CurrentBusinessAtom);

  const setCurrentBusiness = (businessId: string | null) => {
    syncCurrentBusinessToStorage(businessId);
    setCurrentBusinessId(businessId);
  };

  return {
    currentBusinessId,
    setCurrentBusiness,
  };
};
